export default "__VITE_ASSET__Fb$GGuzp__"